<script lang="ts" setup>
import type { StudentProgress } from '../../models/Activity'
import { ref, onMounted } from 'vue'
import { useAssignmentStore } from '../../stores/assignments'
import ActivityAssignmentLine from './ActivityAssignmentLine.vue'
import { KsExpand } from '@aschehoug/kloss'
import { KsCallout } from '@aschehoug/kloss'
import { useI18n } from '../../composables/useI18n'

const { t } = useI18n()

const {
  loadDecoratedStudentProgress,
  getFormWriterIdFromStudentProgress,
} = useAssignmentStore()

const studentProgresses = ref<StudentProgress[]>([])
const isLoading = ref<boolean>(true)
const showCallout = ref<boolean>(false)

const props = defineProps<{
  studentList: StudentProgress[]
}>()

onMounted(async () => {
  isLoading.value = true

  const formWriterId = getFormWriterIdFromStudentProgress(props.studentList)

  try {
    studentProgresses.value = await loadDecoratedStudentProgress(
      props.studentList,
      `form_writer-${formWriterId}`
    )
  } catch (error) {
    showCallout.value = true
    throw error
  } finally {
    isLoading.value = false
  }
})
</script>

<template>
  <KsExpand v-if="!isLoading && !showCallout">
    <ActivityAssignmentLine
      v-for="studentProgress in studentProgresses"
      :key="studentProgress.user.userId"
      :studentProgress="studentProgress"
    />
  </KsExpand>
  <KsCallout
    v-if="!isLoading && showCallout"
    variant="warning"
    :title="t('activity.callout.noData.title')"
    :dismissable="false"
  >
    {{ t('activity.callout.noData.message') }}
  </KsCallout>
</template>
